import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import MenuDialogBase from "./MenuDialogBase";
import { getApplDetailParams } from "../../../util/functions";
import { useApplicationSaveReviewMutation} from "../../../services/graphql/api";
import { selector as rubricSelector } from "../../slices/rubricValues";
import { selector as checkableNotes, getSubmittableNotes } from '../../slices/administrativeNotes';

export default function DialogSaveReview({ menuItemAndClose }) {
    const params = getApplDetailParams();

    // redux values
    const rubricValues = useSelector(rubricSelector);
    const administrativeNotes = useSelector(checkableNotes);
   
    const [applicationSaveReview, result] = useApplicationSaveReviewMutation();

    const adminNotesForInput = useMemo(() => getSubmittableNotes(administrativeNotes ?? []), [administrativeNotes]);

    const apiCall = async () => { 
      params.resumeLater = true;
      params.rubricValues = JSON.stringify(rubricValues ?? {});
      params.administrativeNotes = adminNotesForInput;
      await applicationSaveReview(params);   
      navigate('/');
    };

    const variables = useMemo(() => ({}), [rubricValues, administrativeNotes, params]);
    const isDisabled = result?.isLoading;
    const buttons = [{ label: "Save", apiCall, variables, isDisabled }];
   
    const navigate = useNavigate()
    const wrappedMenuItemAndClose = {
      ...menuItemAndClose,
      close: () => {
        menuItemAndClose.close();    
      }
    }
    
    return (
        <MenuDialogBase
            menuItemAndClose={wrappedMenuItemAndClose}
            apiCall={apiCall}
            buttons={buttons}
            result={result}
    />
  );
}

